const moduleB = {
	state: {
		moduleCountA: 'aaaaaaa'
	},
	mutations: {},
	actions: {},
	getters: {}
}
export default moduleB



// WEBPACK FOOTER //
// ./src/store/modules/moduleA.js